import React, { useEffect, useState } from "react";
import { useTabs } from "../hooks/useTabs";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import Spin from "../ui/Spin";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Input from "../ui/Input";
import Status from "../ui/Status";
import { InfoIcon } from "../utils/Icons";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { ROUTES } from "../utils/Routes";
import EnumField from "../ui/EnumField";
import { arrayToObject, bm_date, bm_time, drawPrice, moveItem } from "../utils/Utils";
import Divider from "../ui/Divider";
import PriceField from "../ui/PriceField";
import dayjs from "dayjs";
import VirtualTable from "../ui/VirtualTable";
import Nav from "../ui/Nav";
import Float from "../ui/Float";

export default function POSGiftCardActivity(props) {

    const { controller = "", route = "", callback = () => { }, data = {}, header = {} } = props;

    const [loading, setLoading] = useState(false);
    const [align, setAlign] = useState("start")
    const [selected, setSelected] = useState(data?.activity?.length ? data?.activity?.[0] : {})
    const row_key = "invoice";

    const {
        balance = 0,
        last_issued_date = 0,
        last_redeemed_date = 0,
        number = "",
        pin = "",
        total_issued = 0,
        total_redeemed = 0,
        activity = []
    } = data;


    //     {
    //     "clerk_code": "Z",
    //     "date": 1765755480000,
    //     "invoice": "L04209",
    //     "price": 2500,
    //     "store_number": ""
    // }

    useEffect(() => {


        const actions = [
            {
                key: KBD.ESCAPE, action: () => {
                    callback();
                }
            },

        ]

        const cleanup = listen(
            controller,
            route,
            actions,
            false,
            [KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.ESCAPE, KBD.PAGE_DOWN]
        );

        return cleanup;
    }, []);



    const columns = [
        {
            key: "date", title: <>Date</>, align: "left", width: 100, render: (e) => {
                return <span style={{"fontFamily" : "var(--font-mono)"}}>{bm_date(e)}</span>;
            }
        },
        {
            key: "date", title: <>Time</>, align: "left", width: 100, render: (e, f) => {
                return dayjs(f.date).format("h:MM a");
            }
        },
        {
            key: "invoice", title: <>Invoice#</>, align: "left", width: 100, grow: true, render: (e, f) => {
                return e;
            }
        },
        { key: "clerk_code", title: <>C</>, align: "left", width: 23 },
        {
            key: "price", title: <>Amount</>, align: "right", width: 100, render: (e) => {
                return drawPrice(e, true)
            }
        },
    ]

    const nav = [
        { text: "AgainSrch", action: () => { } },
        { text: "Prt", action: () => { } },
        { text: "Srch", action: () => { } },
    ]

       const nextRow = (_rows = 1) => {
            moveItem({ data: data?.activity || [], selected, setSelected, row_key: row_key, step: _rows, setAlign, alignOnMove: false })
        };
        const prevRow = (_rows = 1) => {
            moveItem({ data: data?.activity || [], selected, setSelected, row_key: row_key, step: -_rows, setAlign, alignOnMove: true })
        };


    return (
        <div style={{ "width": "610px" }}>
            <Spin loading={loading}>
                <div className="shim" /><div className="shim" />
                <Space>
                    <Label>Gift card# <span style={{ "color": "var(--text)" }}>{number}</span> activity as of <span style={{ "color": "var(--text)" }}>{bm_date(dayjs().valueOf())}</span></Label>
                </Space>
                <div className="shim" /><div className="shim" />
                <VirtualTable
                    controller={controller}

                    // headerClass="danger"

                    next={nextRow}
                    prev={prevRow}
                      onRowClick={(item, event, index) => { setAlign("auto"); setSelected(item) }}
                    align={"auto"}
                    row_key={row_key}
                    current={selected}
                    data={data?.activity || []}
                    columns={columns}
                    // width={960}
                    loading={loading}
                    height={180}
                    offset={0}
                    route={route}
                />
                <div className="shim" />



            </Spin>

            <div style={{ 'height': "20px" }}>
                <Float>
                    <Space style={{ "padding": "0px 0px" }}>
                        <Nav nav={nav} />
                    </Space>
                    <Label>Balance on card <span style={{ "color": "var(--text-yellow)" }}>{drawPrice(balance, true)}</span>&nbsp;</Label>
                </Float>

            </div>

            {/* <Status type="active"><InfoIcon />{statusus[index]}</Status> */}
        </div>
    )
}